import { Injectable, OnInit, Inject, AfterViewInit } from "@angular/core";
import { NotificacaoService, DialogService, LoadingService, BaseService } from "../services";
import { ComponentsModule } from "../components/components.module";
import { AppModule } from "../app.module";
import * as moment from 'moment';
import { Router } from "@angular/router";
import { Title } from "@angular/platform-browser";
import { Subscription } from "rxjs/Subscription";
import { TranslateService } from "@ngx-translate/core";

@Injectable()
export class BaseController implements OnInit, AfterViewInit {
    _notificationsService: NotificacaoService;
    _dialog: DialogService;
    _loading: LoadingService;
    _usuarioLogado: any;
    model: any = {};    
    translate: TranslateService;
    subTitulo: Subscription;
    service: BaseService;   
    
    constructor( _service: BaseService) {
        this._dialog = ComponentsModule.injector.get(DialogService);
        this._loading = ComponentsModule.injector.get(LoadingService);
        this._notificationsService = AppModule.injector.get(NotificacaoService);
        this._usuarioLogado = JSON.parse(localStorage.getItem('currentUserCobranca'));
        this.translate = AppModule.injector.get(TranslateService);
        this.setTitulo();
        this.service=_service;
    }


    ngOnInit() { }
    ngAfterViewInit() { }

    private setTitulo() {
        let router = AppModule.injector.get(Router);
        let title = AppModule.injector.get(Title);

        this.subTitulo = router.events.subscribe(event => {
            var titulo = this.getTitle(router.routerState, router.routerState.root).join('-');
            title.setTitle(titulo);
        });
    }
    private getTitle(state, parent) {
        var data = [];
        if (parent && parent.snapshot.data && parent.snapshot.data.title) {
            this.translate.get(parent.snapshot.data.title).subscribe((res: string) => {
                data.push(res);
            });
        }

        if (state && parent) {
            data.push(... this.getTitle(state, state.firstChild(parent)));
        }
        return data;
    }

    formataTelefone(value: any) {          
        var valor = value.replace(/\D/g, '');        
        var mascaraFixo = "(99) 9999-9999";
        var mascaraCelular = "(99) 99999-9999";
        var mascaraUtilizada = "";
        
        if (valor.length <= 10)
          mascaraUtilizada = mascaraFixo;      
        else
          mascaraUtilizada = mascaraCelular;
          
        var pad = mascaraUtilizada.replace(/\D/g, '').replace(/9/g, '_');
    
        var valorMask = valor + pad.substring(0, pad.length - valor.length);
       
        var valorMaskPos = 0;
        valor = '';
        for (var i = 0; i < mascaraUtilizada.length; i++) {
          if (isNaN(parseInt(mascaraUtilizada.charAt(i)))) {
            valor += mascaraUtilizada.charAt(i);
          } else {
            valor += valorMask[valorMaskPos++];
          }
        }
      
        if (valor.indexOf('_') > -1) {
          valor = valor.substr(0, valor.indexOf('_'));
        }
    
        return valor;
    }

    ngOnDestroy() {
        this.subTitulo.unsubscribe();
    }
}


// WEBPACK FOOTER //
// C:/Users/anderson.oshiro/Projetos/Azure/Ipcorp.PortalCobranca/Web/Ipcorp.PortalCobranca.Web/src/app/helpers/base.controller.ts